import React, { useState, useRef } from "react";
import "../Shopidy/CategoryView.css";
import Slider from "react-slick";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const CategorieView = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const sliderRef = useRef(null);

  const next = () => {
    if (sliderRef.current) sliderRef.current.slickNext();
  };
  const previous = () => {
    if (sliderRef.current) sliderRef.current.slickPrev();
  };

  const itemLength = data?.length || 0;
  const isInfinite = itemLength > 6;

  var settings = {
    dots: false,
    infinite: isInfinite,
    speed: 500,
    slidesToShow: Math.min(6, itemLength || 1),
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: Math.min(5, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(4, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(3, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 3,
        },
      },
      {
        breakpoint: 766,
        settings: {
          slidesToShow: Math.min(2, itemLength || 1),
          slidesToScroll: 1,
          infinite: itemLength > 2,
        },
      },
    ],
  };

  return (
    <>
      <div className="categories-container">
        {loading ? (
          <div className="loader-container">
            <img
              src={require("../FormParser/images/loader.gif")}
              alt="Loading..."
            />
          </div>
        ) : (
          <div className="container">
            <h2 className="cat-section-title">Shop by category</h2>
            {data && data.length > 0 ? (
              <div className="slider-container" style={{ position: "relative" }}>
                <Slider ref={sliderRef} {...settings}>
                  {data.map((itemObj, index) => {
                    return (
                      <div className="px-1" key={index}>
                        <div className="cat-item">
                          <div className="cat-img">
                            <img
                              src={
                                itemObj.image__image
                                  ? itemObj.image__image
                                  : itemObj.image
                              }
                              className="mx-auto image-fluid"
                              alt={itemObj.name}
                            />
                          </div>
                          <div className="cat-title">
                            <p>{itemObj.name}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
                {data.length > 6 && (
                  <>
                    <div className="slick-arrow" style={{ left: "-15px", top: "25%", background: "#fff" }}>
                      <MdChevronLeft size={30} onClick={previous} />
                    </div>
                    <div className="slick-arrow" style={{ right: "-15px", left: "auto", top: "25%", background: "#fff" }}>
                      <MdChevronRight size={30} onClick={next} />
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="text-center py-4">No categories configured</div>
            )}
          </div>
        )}
      </div>
    </>
  );
};
export { CategorieView };
